module.exports = __webpack_public_path__ + "img/box.3a77730e.svg";